export default __webpack_public_path__ + "static/media/logo-us-michaelkors.05d923d5.svg";